var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0b32d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    className: "cls-1",
    d: "M847.93,382.17c.49,6.87.49,13.77.49,20.65,1.73,247.91-197.85,450.29-445.76,452H396.4a449,449,0,0,1-243.95-71.32,327.69,327.69,0,0,0,38.36,2,318.18,318.18,0,0,0,197.24-67.91A159.14,159.14,0,0,1,239.53,607.42a199.52,199.52,0,0,0,30,2.45,167.87,167.87,0,0,0,41.79-5.48A158.89,158.89,0,0,1,183.9,448.48v-2a160.11,160.11,0,0,0,71.82,20.15,159.13,159.13,0,0,1-49.19-212.59A451.57,451.57,0,0,0,534.12,420.32a178.94,178.94,0,0,1-3.93-36.4,159,159,0,0,1,275-108.6A312.73,312.73,0,0,0,906,237a158.48,158.48,0,0,1-69.89,87.54,318.52,318.52,0,0,0,91.47-24.58,341.62,341.62,0,0,1-79.68,82.15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e598df9703829e0688244c66eb341706.svg";
export { ForwardRef as ReactComponent };